<script setup lang="ts">
import { useClipboard } from "@vueuse/core"
import { Icon } from "@/components/ui"

interface ClipboardButtonProps {
  content: string
}

defineProps<ClipboardButtonProps>()

const { isSupported, copy, copied } = useClipboard()
</script>

<template>
  <button
    v-if="isSupported"
    class="flex font-comfortaa font-bold text-sm items-center text-link hover:text-link-hover hover:underline focus:underline cursor-pointer"
    @click.prevent="() => copy(content)"
  >
    <transition name="gpx-fade">
      <Icon :icon="copied ? 'CircleCheck' : 'Copy'" class="mr-2" />
    </transition>
    <slot />
  </button>
</template>
